import { Builder } from "@builder.io/react";
import { StaticImage } from "gatsby-plugin-image";
import { toMutable } from "types/common";
import * as styles from "./styles.module.scss";

const inputs = [
    {
        name: "title",
        type: "text",
        defaultValue: "AY Help Center Brings Support To Your Fingertip.",
    },
    {
        name: "subtitle",
        type: "text",
        defaultValue: "Welcome to our help center. Your one-stop knowledge base. We are here to help.",
    },
    {
        name: "placeholder",
        type: "text",
        defaultValue: "Search",
    },
] as const;

const AyHelpCenterHero: BFC<typeof inputs> = ({ title, subtitle }) => {
    return (
        <div className="container">
            <div className={`${styles.firstGlow} gradient`}>
                <StaticImage src="./images/ay-help-center-hero-first-glow.svg" alt="" />
            </div>
            <div className={`${styles.secondGlow} gradient`}>
                <StaticImage src="./images/ay-help-center-hero-second-glow.svg" alt="" />
            </div>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.subtitle}>{subtitle}</p>
        </div>
    );
};

Builder.registerComponent(AyHelpCenterHero, {
    name: "ayHelpCenterHero",
    inputs: toMutable(inputs),
});
